import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import queryString from 'query-string';
import { RootState } from '../../modules';
import {
  setSearchKeyword,
  searchKeywordState,
} from '../../modules/searchKeyword';

import Search from '../../components/search';

type SearchContainerProp = RouteComponentProps;

function SearchContainer({ match, location, history }: SearchContainerProp) {
  const dispatch = useDispatch();

  const onSetSearchKeyword = (
    searchKeyword: searchKeywordState['searchKeyword']
  ) => {
    dispatch(setSearchKeyword(searchKeyword));
  };

  function isString(val: string | string[]): val is string {
    return typeof val === 'string';
  }

  const setLocalStorage = (keyword: any) => {
    const searchList = localStorage.getItem('aivorySearchList');

    if (searchList) {
      const arr = JSON.parse(searchList);
      const isFind = arr.indexOf(keyword);
      if (isFind === -1) {
        arr.push(keyword);
        localStorage.setItem('aivorySearchList', JSON.stringify(arr));
      }
    } else {
      localStorage.setItem('aivorySearchList', JSON.stringify([keyword]));
    }
  };

  useEffect(() => {
    const query = queryString.parse(location.search);
    let keyword: string | string[];
    if (query.q) {
      if (isString(query.q)) {
        keyword = query.q;
      } else {
        const index = 0;
        keyword = query.q[index];
      }
      setLocalStorage(keyword);

      onSetSearchKeyword(keyword);
    }
  }, []);

  return (
    <Search
      onSetSearchKeyword={onSetSearchKeyword}
      match={match}
      location={location}
      history={history}
    />
  );
}

export default SearchContainer;
